<template>
  <Card class="layout-card" style="height: 100%">
    <div
      style="
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
        flex-shrink: 0;
      "
    >
      <div class="search-form">
        <Input
          :maxlength="100"
          v-model="searchForm.tagName"
          placeholder="请输入标签名称"
        />
        <Input
          :maxlength="100"
          v-model="searchForm.tagDesc"
          placeholder="请输入描述"
        />
        <div>
          <Select
            style="width: 120px"
            v-model="searchForm.tagStatus"
            placeholder="请选择"
            allow-clear
          >
            <Option :value="1">启用</Option>
            <Option :value="0">禁用</Option>
          </Select>
        </div>
        <Button type="primary" v-if="buttonMenu['/tag/view']" @click="getData()"
          >查询</Button
        >
        <Button @click="handleReset()">重置</Button>
      </div>
      <div>
        <Button
          type="primary"
          v-if="buttonMenu['/tag/add']"
          @click="handleOpenEditModal()"
          >添加</Button
        >
      </div>
    </div>
    <div style="height: 100%; overflow: auto">
      <Table :data="tableData" :columns="columns">
        <template #status="{ row }">
          <div>
            <i-switch
              v-if="buttonMenu['/tag/switch']"
              :value="row.tagStatus"
              :before-change="() => handleChangeStatus(row)"
              @on-change="row.tagStatus = $event"
            ></i-switch>
            <span v-else>{{ row.tagStatus ? '开启' : '禁用' }}</span>
          </div>
        </template>
        <template #action="{ row }">
          <div>
            <a
              style="margin-left: 10px"
              v-if="buttonMenu['/tag/edit']"
              @click="handleOpenEditModal(row)"
              >编辑</a
            >
            <Poptip
              confirm
              title="确定要删除吗？"
              v-if="buttonMenu['/tag/delete']"
              transfer
              @on-ok="handleDel(row)"
              ><a style="margin-left: 10px; color: red">删除</a></Poptip
            >
          </div>
        </template>
        <Pages slot="footer" :page="page" :func="getData"></Pages>
      </Table>
    </div>

    <Modal v-model="editVisible" :title="(form.id ? '编辑' : '新增') + '标签'">
      <Form
        @submit.native.prevent
        :label-width="100"
        :model="form"
        ref="formRef"
        v-if="editVisible"
      >
        <FormItem
          label="标签名称："
          prop="tagName"
          :rules="[{ required: true, message: '请输入标签名称' }]"
        >
          <Input
            :maxlength="30"
            v-model="form.tagName"
            @on-blur="form.tagName = limitstr(form.tagName, 30)"
          />
        </FormItem>
        <FormItem
          label="中文名称："
          prop="tagChineseName"
          :rules="[{ required: true, message: '请输入中文名称' }]"
        >
          <Input :maxlength="30" v-model="form.tagChineseName" />
        </FormItem>
        <FormItem
          label="语言："
          prop="langId"
          :rules="[{ required: true, message: '请选择所属语言' }]"
        >
          <Select
            v-model="form.langId"
            placeholder="请选择语言"
            @on-change="
              playTypeList = []
              playTagList = []
            "
          >
            <Option
              v-for="(item, index) in langList"
              :key="index"
              :value="item.id"
              >{{ item.chineseLangName }}</Option
            >
          </Select>
        </FormItem>
        <FormItem
          label="标签描述："
          prop="tagDesc"
          :rules="[{ required: true, message: '请输入标签描述' }]"
        >
          <Input type="textarea" :maxlength="200" v-model="form.tagDesc" />
        </FormItem>
        <FormItem
          label="标签状态："
          prop="tagStatus"
          :rules="[{ required: true, message: '请选择' }]"
        >
          <i-switch v-model="form.tagStatus" />
        </FormItem>
      </Form>
      <template #footer>
        <Button @click="editVisible = false">取消</Button>
        <Button type="primary" :loading="submitLoading" @click="handleSubmit()"
          >提交</Button
        >
      </template>
    </Modal>
  </Card>
</template>

<script>
import Pages from '@/components/pages'
import {
  getTagList,
  addTag,
  delTag,
  editTag,
  getTagInfo,
  changeTagStatus
} from '@/api/tag'
import { limitstr } from '../../libs/util'
import { getLangList } from '../../api/lang'
export default {
  components: {
    Pages
  },
  data() {
    return {
      editVisible: false,
      limitstr,
      form: {},
      searchForm: {},
      langList: [],
      submitLoading: false,
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      tableData: [],
      columns: [
        // {
        //   title: 'id',
        //   key: 'id'
        // },
        {
          title: '标签名称',
          key: 'tagName'
        },
        {
          title: '中文名称',
          key: 'tagChineseName'
        },
        {
          title: '语言',
          key: 'langName'
        },
        {
          title: '标签描述',
          key: 'tagDesc'
        },
        {
          title: '状态',
          key: 'tagStatusName',
          slot: 'status'
        },
        {
          title: '创建人',
          key: 'createUserName'
        },
        {
          title: '创建时间',
          key: 'createTimeFmt'
        },
        {
          title: '修改人',
          key: 'updateUserName'
        },
        {
          title: '修改时间',
          key: 'updateTimeFmt'
        },
        {
          title: '操作',
          align: 'center',
          slot: 'action'
        }
      ]
    }
  },
  computed: {
    buttonMenu() {
      const li = this.$store.getters.getMenuRules('tags/tag')
      console.log(li)

      const obj = {}
      li.forEach((i) => {
        obj[i.menuPath] = true
      })
      return obj
    }
  },
  methods: {
    getData(page) {
      if (page) this.page.current = page
      else this.page.current = 1
      getTagList({
        ...this.page,
        ...this.searchForm
      }).then(({ data }) => {
        console.log(data)

        this.tableData = data.records
        this.page.current = data.current
        this.page.total = data.total
      })
    },
    handleGetLang() {
      getLangList({
        current: -1,
        size: -1
        // , langStatus: true
      }).then((r) => {
        this.langList = r.data.records
      })
    },
    handleChangeStatus(row) {
      changeTagStatus(row.id)
        .then((r) => {
          this.$Message.success('操作成功')
          this.getData(this.page.current)
        })
        .catch((e) => {
          this.$Message.error('操作失败')
        })
      return new Promise(() => {})
    },
    async handleOpenEditModal(row) {
      if (row) {
        const r = await getTagInfo(row.id)
        this.form = r.data
      } else {
        this.form = {
          tagStatus: false
        }
      }
      this.editVisible = true
    },
    handleSubmit() {
      this.$refs.formRef.validate((r) => {
        if (r) {
          const func = this.form.id ? editTag : addTag
          this.submitLoading = true
          func({
            ...this.form
          })
            .then((r) => {
              this.$Message.success('操作成功')
              this.getData()
              this.submitLoading = false
              this.editVisible = false
            })
            .catch(() => {
              this.submitLoading = false
            })
        }
      })
    },
    handleDel(row) {
      delTag(row.id).then((r) => {
        this.$Message.success('操作成功')
        this.getData()
      })
    },
    handleReset() {
      this.searchForm = {}
    }
  },
  mounted() {
    this.getData()
    this.handleGetLang()
  }
}
</script>

<style scoped lang="less">
.search-form {
  display: flex;
  & > * {
    margin: 0 5px;
  }
}
.layout-card {
  /deep/ .ivu-card-body {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
}
</style>
